/*
 * bpmbuild-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/FlowRequest', 'model/FlowResponse', 'model/PartBean', 'model/PartResponse', 'model/ProductBean', 'model/ProductResponse'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./FlowRequest'), require('./FlowResponse'), require('./PartBean'), require('./PartResponse'), require('./ProductBean'), require('./ProductResponse'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildDevelopmentappspotcom) {
      root.BpmbuildDevelopmentappspotcom = {};
    }
    root.BpmbuildDevelopmentappspotcom.ProductBean = factory(root.BpmbuildDevelopmentappspotcom.ApiClient, root.BpmbuildDevelopmentappspotcom.FlowRequest, root.BpmbuildDevelopmentappspotcom.FlowResponse, root.BpmbuildDevelopmentappspotcom.PartBean, root.BpmbuildDevelopmentappspotcom.PartResponse, root.BpmbuildDevelopmentappspotcom.ProductBean, root.BpmbuildDevelopmentappspotcom.ProductResponse);
  }
}(this, function(ApiClient, FlowRequest, FlowResponse, PartBean, PartResponse, ProductBean, ProductResponse) {
  'use strict';

  /**
   * The ProductBean model module.
   * @module model/ProductBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>ProductBean</code>.
   * @alias module:model/ProductBean
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>ProductBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ProductBean} obj Optional instance to populate.
   * @return {module:model/ProductBean} The populated <code>ProductBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('attributeSetId'))
        obj.attributeSetId = ApiClient.convertToType(data['attributeSetId'], 'String');
      if (data.hasOwnProperty('beanInstance'))
        obj.beanInstance = PartBean.constructFromObject(data['beanInstance']);
      if (data.hasOwnProperty('catalogueId'))
        obj.catalogueId = ApiClient.convertToType(data['catalogueId'], 'String');
      if (data.hasOwnProperty('categoryId'))
        obj.categoryId = ApiClient.convertToType(data['categoryId'], 'String');
      if (data.hasOwnProperty('codeTag'))
        obj.codeTag = ApiClient.convertToType(data['codeTag'], 'String');
      if (data.hasOwnProperty('configurableFieldList'))
        obj.configurableFieldList = ApiClient.convertToType(data['configurableFieldList'], ['String']);
      if (data.hasOwnProperty('cost'))
        obj.cost = ApiClient.convertToType(data['cost'], 'String');
      if (data.hasOwnProperty('customPropertiesJson'))
        obj.customPropertiesJson = ApiClient.convertToType(data['customPropertiesJson'], 'String');
      if (data.hasOwnProperty('dateCreated'))
        obj.dateCreated = ApiClient.convertToType(data['dateCreated'], 'Date');
      if (data.hasOwnProperty('fileUrls'))
        obj.fileUrls = ApiClient.convertToType(data['fileUrls'], ['String']);
      if (data.hasOwnProperty('flowId'))
        obj.flowId = ApiClient.convertToType(data['flowId'], 'String');
      if (data.hasOwnProperty('flowRequestList'))
        obj.flowRequestList = ApiClient.convertToType(data['flowRequestList'], [FlowRequest]);
      if (data.hasOwnProperty('flowResponseList'))
        obj.flowResponseList = ApiClient.convertToType(data['flowResponseList'], [FlowResponse]);
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('imageUrls'))
        obj.imageUrls = ApiClient.convertToType(data['imageUrls'], ['String']);
      if (data.hasOwnProperty('kanbanBoardId'))
        obj.kanbanBoardId = ApiClient.convertToType(data['kanbanBoardId'], 'String');
      if (data.hasOwnProperty('lastUpdatedDateTime'))
        obj.lastUpdatedDateTime = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      if (data.hasOwnProperty('longDescription'))
        obj.longDescription = ApiClient.convertToType(data['longDescription'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('operationalType'))
        obj.operationalType = ApiClient.convertToType(data['operationalType'], 'String');
      if (data.hasOwnProperty('parentId'))
        obj.parentId = ApiClient.convertToType(data['parentId'], 'String');
      if (data.hasOwnProperty('partList'))
        obj.partList = ApiClient.convertToType(data['partList'], [PartResponse]);
      if (data.hasOwnProperty('partProductJson'))
        obj.partProductJson = ApiClient.convertToType(data['partProductJson'], 'String');
      if (data.hasOwnProperty('price'))
        obj.price = ApiClient.convertToType(data['price'], 'String');
      if (data.hasOwnProperty('productBeanInstance'))
        obj.productBeanInstance = ProductBean.constructFromObject(data['productBeanInstance']);
      if (data.hasOwnProperty('productList'))
        obj.productList = ApiClient.convertToType(data['productList'], [ProductResponse]);
      if (data.hasOwnProperty('productType'))
        obj.productType = ApiClient.convertToType(data['productType'], 'String');
      if (data.hasOwnProperty('quantity'))
        obj.quantity = ApiClient.convertToType(data['quantity'], 'Number');
      if (data.hasOwnProperty('shortDescription'))
        obj.shortDescription = ApiClient.convertToType(data['shortDescription'], 'String');
      if (data.hasOwnProperty('sku'))
        obj.sku = ApiClient.convertToType(data['sku'], 'String');
      if (data.hasOwnProperty('stockType'))
        obj.stockType = ApiClient.convertToType(data['stockType'], 'String');
      if (data.hasOwnProperty('supplierId'))
        obj.supplierId = ApiClient.convertToType(data['supplierId'], 'String');
      if (data.hasOwnProperty('type'))
        obj.type = ApiClient.convertToType(data['type'], 'String');
      if (data.hasOwnProperty('userId'))
        obj.userId = ApiClient.convertToType(data['userId'], 'String');
    }
    return obj;
  }

  /**
   * @member {String} attributeSetId
   */
  exports.prototype.attributeSetId = undefined;

  /**
   * @member {module:model/PartBean} beanInstance
   */
  exports.prototype.beanInstance = undefined;

  /**
   * @member {String} catalogueId
   */
  exports.prototype.catalogueId = undefined;

  /**
   * @member {String} categoryId
   */
  exports.prototype.categoryId = undefined;

  /**
   * @member {String} codeTag
   */
  exports.prototype.codeTag = undefined;

  /**
   * @member {Array.<String>} configurableFieldList
   */
  exports.prototype.configurableFieldList = undefined;

  /**
   * @member {String} cost
   */
  exports.prototype.cost = undefined;

  /**
   * @member {String} customPropertiesJson
   */
  exports.prototype.customPropertiesJson = undefined;

  /**
   * @member {Date} dateCreated
   */
  exports.prototype.dateCreated = undefined;

  /**
   * @member {Array.<String>} fileUrls
   */
  exports.prototype.fileUrls = undefined;

  /**
   * @member {String} flowId
   */
  exports.prototype.flowId = undefined;

  /**
   * @member {Array.<module:model/FlowRequest>} flowRequestList
   */
  exports.prototype.flowRequestList = undefined;

  /**
   * @member {Array.<module:model/FlowResponse>} flowResponseList
   */
  exports.prototype.flowResponseList = undefined;

  /**
   * @member {String} id
   */
  exports.prototype.id = undefined;

  /**
   * @member {Array.<String>} imageUrls
   */
  exports.prototype.imageUrls = undefined;

  /**
   * @member {String} kanbanBoardId
   */
  exports.prototype.kanbanBoardId = undefined;

  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype.lastUpdatedDateTime = undefined;

  /**
   * @member {String} longDescription
   */
  exports.prototype.longDescription = undefined;

  /**
   * @member {String} name
   */
  exports.prototype.name = undefined;

  /**
   * @member {String} operationalType
   */
  exports.prototype.operationalType = undefined;

  /**
   * @member {String} parentId
   */
  exports.prototype.parentId = undefined;

  /**
   * @member {Array.<module:model/PartResponse>} partList
   */
  exports.prototype.partList = undefined;

  /**
   * @member {String} partProductJson
   */
  exports.prototype.partProductJson = undefined;

  /**
   * @member {String} price
   */
  exports.prototype.price = undefined;

  /**
   * @member {module:model/ProductBean} productBeanInstance
   */
  exports.prototype.productBeanInstance = undefined;

  /**
   * @member {Array.<module:model/ProductResponse>} productList
   */
  exports.prototype.productList = undefined;

  /**
   * @member {String} productType
   */
  exports.prototype.productType = undefined;

  /**
   * @member {Number} quantity
   */
  exports.prototype.quantity = undefined;

  /**
   * @member {String} shortDescription
   */
  exports.prototype.shortDescription = undefined;

  /**
   * @member {String} sku
   */
  exports.prototype.sku = undefined;

  /**
   * @member {String} stockType
   */
  exports.prototype.stockType = undefined;

  /**
   * @member {String} supplierId
   */
  exports.prototype.supplierId = undefined;

  /**
   * @member {String} type
   */
  exports.prototype.type = undefined;

  /**
   * @member {String} userId
   */
  exports.prototype.userId = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/model/ProductBean.js